<template>
    <div>
        <div class="error-dialog-header">
            <span>{{messageHeader}}</span>
        </div>
        <div class="error-dialog-body">
            <pre><span v-html="errors"></span></pre>
        </div>
        <div class="error-dialog-footer">
          <button type="button" class="btn btn-secondary" v-if="confirmDelete" @click="$modal.hide(modalName)">Cancel</button>
          <button type="button" class="btn btn-primary" @click="closeModel" title="Close">Ok</button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MessagePopup',
  props: {
    errors: Array,
    messageHeader: String,
    isError: Boolean,
    confirmDelete: {
      type: Boolean,
      default: false
    },
    modalName: {
      type: String,
      default: 'MessagePopup'
    }
  },

  methods: {
    closeModel () {
      if (this.confirmDelete) {
        this.$emit('CloseModal')
        this.$modal.hide(this.modalName)
        document.body.style.overflow = "";
      } else {
        if (!this.isError) {
          this.$emit('CloseModal')
        }
        this.$modal.hide(this.modalName)
        document.body.style.overflow = "";
      }
    }
  }
}
</script>

<style scoped>
    .error-dialog-header {
        height: 35px;
        background-color: #2A95CC;
        padding: 8px;
        top: 0;
        color: white;
        font-weight: 700;
        font-size: 13px;
    }

    .error-dialog-body pre{
        background-color: white;
        font-family: 'Helvetica',sans-serif;
        padding: 15px;
        font-weight: 600;
        font-size: 12px;
        border:none;
        text-align: center;
    }

    .error-dialog-footer {
        height: 50px;
        width:100%;
        position:relative;
        bottom: 0;
        padding: 7px;
        border-top: 1px solid #428bca;
    }
    .error-dialog-footer btn btn-secondary {
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075) !important;
        background-color: #e5e5e5 !important;
    }

    .error-dialog-footer button {
        margin-left: 9px;
        float: right;
        border-radius: 0px;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075) !important;
        padding: 3px 15px !important;
        font-size: 11px !important;
        font-weight: 600;
        margin-top: 10px !important;
    }

</style>
